/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wb_S2Inputs */

const en_tut_wb_s2 = /** @type {(inputs: Tut_Wb_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a tool: **Catatan tempel**, **Teks**, **Persegi panjang**, **Elips**, or **Gambar bebas**. Double-click an object to edit its text.`)
};

const id_tut_wb_s2 = /** @type {(inputs: Tut_Wb_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih alat: **Catatan tempel**, **Teks**, **Persegi panjang**, **Elips**, atau **Gambar bebas**. Klik dua kali pada objek untuk menyunting teksnya.`)
};

/**
* | output |
* | --- |
* | "Pick a tool: **Catatan tempel**, **Teks**, **Persegi panjang**, **Elips**, or **Gambar bebas**. Double-click an object to edit its text." |
*
* @param {Tut_Wb_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wb_s2 = /** @type {((inputs?: Tut_Wb_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wb_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wb_s2(inputs)
	return en_tut_wb_s2(inputs)
});